import React, { Fragment } from "react";
import { CircularProgress, Collapse, IconButton, InputAdornment, List, ListItemButton, ListItemText, OutlinedInput, Popover, useTheme } from "@mui/material";
import { SelectedNestedListProps } from "./types";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import SearchIcon from "@mui/icons-material/Search";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const SelectNestedList: React.FC<SelectedNestedListProps> = (({
    items,
    placeholder,
    isLoading,
    defaultValue,
    showAdortments = true,
    isInForm = false,
    onChangeItem,
    onSearch,
}) => {
    const [anchorEl, setAnchorEl] = React.useState<HTMLInputElement | null>(null);
    const [searchValue, setSearchValue] = React.useState<string>(defaultValue || '');
    const [isOpenSecond, setIsOpenSecond] = React.useState<number>(0);
    const [isOpenThird, setIsOpenThird] = React.useState<number>(0);
    const open = Boolean(anchorEl);
    const theme = useTheme();

    const handleClick = (event: React.MouseEvent<HTMLInputElement>) => {
        setAnchorEl(event.currentTarget);
    };
    
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleListClick = (value: number, level: 'first' | 'second' | 'third') => {
        let shouldCallback = false
        switch(level){
            case 'first':
                setIsOpenSecond((old) => {
                    if(old === value){
                        return 0;
                    } 
                    shouldCallback = true;
                    return value 
                });
                break;
            case 'second':
                setIsOpenThird((old) => {
                    if(old === value){
                        return 0;
                    } 
                    shouldCallback = true;
                    return value 
                });
                break;
            case 'third':
                shouldCallback = true;
                const label = items.third.find((item) => item.value === value )?.label;
                if(label){
                    setSearchValue(label);
                    setAnchorEl(null);
                }
                break;
            default:
                console.error("Error level not found");
                break;
        }
        if(onChangeItem && shouldCallback) onChangeItem(value, level);
    }

    const renderList = (level: 'first' | 'second' | 'third') => {
        const internalOpen = level === 'first' ? isOpenSecond : isOpenThird; 
        return items[level].map((item) => (
            <Fragment key={item.label}>
                <ListItemButton 
                    style={{paddingLeft: level === 'second' ? theme.spacing(3) : level === 'third' ? theme.spacing(5) : undefined}} 
                    onClick={() => handleListClick(item.value, level)}>
                    <ListItemText primary={item.label} />
                        { level !== 'third' ? isLoading ? <CircularProgress size={"24px"} /> : internalOpen === item.value ? <ExpandLess /> : <ExpandMore /> : <></>}
                </ListItemButton>
                {level !== 'third' && <Collapse in={internalOpen === item.value && !isLoading} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        {renderList(level === 'first' ? 'second': 'third')}
                    </List>
                </Collapse>}
            </Fragment>
        ))
    }

    return(
        <>
            <OutlinedInput
              onChange={(e) => setSearchValue(e.currentTarget.value)}
              value={searchValue}
              onClick={handleClick}
              fullWidth={true}
              placeholder={placeholder}
              style={{ borderRadius: isInForm ? undefined : "10px", marginBottom: isInForm ? theme.spacing(2) : undefined }}
              size={isInForm ? "medium" : "small"}
              color="secondary"
              readOnly
              startAdornment={ showAdortments &&
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              }
              endAdornment={ showAdortments &&
                <InputAdornment position="end">
                    <IconButton
                      aria-label="search"
                      onClick={() => onSearch && onSearch()}
                      edge="end"
                    >
                      <ArrowForwardIcon color="secondary" />
                    </IconButton>
                  </InputAdornment>
              }
            />
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <List
                    sx={{ width: '100%', maxWidth: 360 }}
                    component="nav"
                >
                    {renderList("first")}
                </List>
            </Popover>
        </>
    )
});

export default SelectNestedList;